import { Component, Input, OnInit } from '@angular/core';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import * as _ from 'underscore';
import * as __ from 'lodash';
import * as moment from "moment";
import { GlobalService } from 'src/app/_services/global.service';


@Component({
  selector: 'app-person-search-activity',
  templateUrl: './person-search-activity.component.html',
  styleUrls: ['./person-search-activity.component.scss']
})
export class PersonSearchActivityComponent implements OnInit {
  @Input() candidateDetails;
  candidateActivity: any[] = []
  activityType: any[] = []
  originalCandidateActivity: [] = []
  sortType: string = 'recent'
  loggedInUserName: string = ''
  constructor(private personSearchService: PersonSearchService, private localstorageservice: LocalStorageService) {
    this.loggedInUserName =  this.localstorageservice.getItem('ufname') + " " + this.localstorageservice.getItem('ulname')  
  }


  ngOnInit(): void {
    const elasticid = this.candidateDetails.id
    this.personSearchService.getCandidateActivity(elasticid).subscribe((result: any) => {
      if (result && result.status == 'success') {
        this.originalCandidateActivity = __.cloneDeep(result.message)
        this.candidateActivity = result.message
        this.activityType = _.uniq(this.candidateActivity.map(x => x.activitytype))
        this.sortActivity(this.sortType)
      }
    });
  }

  sortActivity(type: any): void {
    // sort activity based on createdon on recent and oldest
    this.sortType = type
    if (type === 'recent') {
      this.candidateActivity.sort((a, b) => {
        return new Date(b.createdon).getTime() - new Date(a.createdon).getTime();
      });
    } else if (type === 'oldest') {
      this.candidateActivity.sort((a, b) => {
        return new Date(a.createdon).getTime() - new Date(b.createdon).getTime();
      });
    }
  }

  filterByActivityType(type: any) {
    if (type === 'all') {
      this.candidateActivity = this.originalCandidateActivity
    } else {
      this.candidateActivity = this.originalCandidateActivity.filter((obj: any) => obj.activitytype === type)
    }
    this.sortActivity(this.sortType)
  }


  getActivityText(activity) {
   return GlobalService.getPersonSearchActivityText(activity)
  }
}
